// extracted by mini-css-extract-plugin
module.exports = {"isViewOnlyModeWrapper":"AssetLink_isViewOnlyModeWrapper__FSB00","isViewOnlyMode":"AssetLink_isViewOnlyMode__0SYXV","offsiteLink":"AssetLink_offsiteLink__6v_12"};